import React from 'react'
import Popup from './Popup'
import { Spinner } from './Spinner'

const SpinnerPopup: React.FunctionComponent<{
  children: React.ReactNode
}> = (props) => {
  return (
    <Popup
      onClose={() => {
        return
      }}
    >
      <div className="title">{props.children}</div>
      <Spinner/>
    </Popup>
  )
}

export default SpinnerPopup
